import { NavLink } from 'react-router'

export default function LandingFooter() {
  return (
    <footer className="bg-white" aria-labelledby="footer-heading">
      <div className="mx-auto max-w-7xl px-6 pb-8 lg:px-8">
        <div className="mx-auto max-w-4xl">
          <div className="border-t border-gray-900/10 pt-8 md:flex md:items-center md:justify-between">
            <div className="flex flex-col space-y-4 md:order-2 md:flex-row md:space-y-0 md:space-x-6">
              <a
                href="/#how-it-works"
                className="text-sm leading-6 text-gray-600 hover:text-gray-900">
                How it works
              </a>
              <NavLink
                to="/pricing"
                className="text-sm leading-6 text-gray-600 hover:text-gray-900">
                Pricing
              </NavLink>
              <NavLink
                to="/about"
                className="text-sm leading-6 text-gray-600 hover:text-gray-900">
                About
              </NavLink>
              <NavLink
                to="/clubs"
                className="text-sm leading-6 text-gray-600 hover:text-gray-900">
                Find a club
              </NavLink>
              <NavLink
                to="/support"
                className="text-sm leading-6 text-gray-600 hover:text-gray-900">
                Support
              </NavLink>
              <a
                href="mailto:support@speechagenda.com"
                className="text-sm leading-6 text-gray-600 hover:text-gray-900">
                support@speechagenda.com
              </a>
            </div>
            <p className="mt-8 text-xs leading-5 text-gray-500 md:order-1 md:mt-0">
              &copy; 2026 Speech Agenda. All rights reserved.
            </p>
          </div>
          <p className="mt-8 text-xs leading-5 text-gray-400">
            Toastmasters International® and all related trademarks are the
            property of Toastmasters International. Speech Agenda is an
            independent product and is not affiliated with or endorsed by
            Toastmasters International.
          </p>
        </div>
      </div>
    </footer>
  )
}
